
import IconCardOne from "../images/icon-card-one.svg";
import IconCardTwo from "../images/icon-card-two.svg";
import IconCardThree from "../images/icon-card-three.svg";
import { useTranslation } from "react-i18next";


const JobsectionsCards = () => {
    const { t, i18n } = useTranslation();

    const CardsList = [
        {
            id: 1,
            icon: IconCardOne,
            title: t("JobsCardTitle1"),
            desc: t("JobsCardDesc1"),
        },
        {
            id: 2,
            icon: IconCardTwo,
            title: t("JobsCardTitle2"),
            desc: t("JobsCardDesc2"),
        },
        {
            id: 3,
            icon: IconCardThree,
            title: t("JobsCardTitle3"),
            desc: t("JobsCardDesc3"),
        }
    ];

    return (
        <section className="job-cards">
            <div className="job-card">
                <div className="img">
                    <img src={CardsList[0].icon} alt={CardsList[0].title} />
                </div>
                <div className="content">
                    <h4>{CardsList[0].title}</h4>
                    <p>{CardsList[0].desc}</p>
                </div>
            </div>
            <div className="job-card-line" />
            <div className="job-card">
                <div className="img">
                    <img src={CardsList[1].icon} alt={CardsList[1].title} />
                </div>
                <div className="content">
                    <h4>{CardsList[1].title}</h4>
                    <p>{CardsList[1].desc}</p>
                </div>
            </div>
            <div className="job-card-line" />
            <div className="job-card">
                <div className="img">
                    <img src={CardsList[2].icon} alt={CardsList[2].title} />
                </div>
                <div className="content">
                    <h4>{CardsList[2].title}</h4>
                    <p>{CardsList[2].desc}</p>
                </div>
            </div>
        </section>
    );
};

export default JobsectionsCards;